import { Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import {
  Router, Resolve, ActivatedRouteSnapshot
}                                 from '@angular/router';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { Observable, of, EMPTY }  from 'rxjs';
import { mergeMap, take, tap }         from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { NeproseService } from '../services/neprose.service';

@Injectable({
  providedIn: 'root'
})
export class PropertyResolverService implements Resolve<any>{

  constructor( private neproseService: NeproseService, private router: Router, private seo: SeoSocialShareService ) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> | Observable<never>{
    return this.neproseService.getAdvertisement(route.paramMap.get('id')).pipe(
      take(1),
      mergeMap(propertyAd=> {
        if (propertyAd) {
          if(propertyAd.propertyAd){
            let property = propertyAd.propertyAd
            this.seo.setTitle(property.title)
            let excerpt = property.details.replace(/<\/?[^>]+(>|$)/g, '')
            if(excerpt){
              this.seo.setDescription(excerpt.slice(0, 100))
            }
            if(property.PropertyImage){
              let propertyImages = JSON.parse(property.PropertyImage.imagePath)
              if(propertyImages.length > 0){
                this.seo.setImage(environment.api+'/images/'+propertyImages[0])
              }
            }
            return of(propertyAd);
          }else{
            this.router.navigate(['404']);
          }
        } else {
          this.router.navigate(['404']);
        }
      })
    )
  }

}
